import React from "react";
import { CalculatorDisplay } from "../stylesCalculator";


export default function Display(props: any) {
    return (
        <CalculatorDisplay >{props.value}</CalculatorDisplay>

    );
}

    

